/* eslint-disable react/no-danger */
import React from 'react';
import { createPortal } from 'react-dom';

const canUseDOM = () => {
  return !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
  );
};

const JsonSchema = data => {
  if (!canUseDOM()) {
    return null;
  }

  return createPortal(
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />,
    document.body
  );
};

export default JsonSchema;
